var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { createContext, useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import client from "../http/client";
import PersistenceManager from "../functions/persistence";
import { normalizeSmsNumber } from "../functions/smsNumber";
import { useAuth } from "./AuthProvider";
var CheckoutValidationError = /** @class */ (function (_super) {
    __extends(CheckoutValidationError, _super);
    function CheckoutValidationError(message, code) {
        var _this = _super.call(this, message) || this;
        _this.name = "CheckoutValidationError";
        _this.code = code;
        return _this;
    }
    return CheckoutValidationError;
}(Error));
export { CheckoutValidationError };
var CheckoutContext = createContext(undefined);
var GENERIC_FINALIZE_ERROR = "We couldn't place your order right now. Please try again.";
var isDeliveryServiceType = function (serviceType) {
    if (!serviceType) {
        return false;
    }
    if (typeof serviceType.has_delivery !== "undefined") {
        return Boolean(serviceType.has_delivery);
    }
    return serviceType.pos_id === 1;
};
var hasAddressSet = function (address) {
    if (!address) {
        return false;
    }
    var hasAddressId = typeof address.id !== "undefined" && address.id !== null && String(address.id).trim().length > 0;
    return hasAddressId;
};
var extractFriendlyMessage = function (error, fallbackMessage) {
    var _a;
    if (!error || typeof error !== "object") {
        return fallbackMessage;
    }
    var candidate = error;
    var responseData = (_a = candidate.response) === null || _a === void 0 ? void 0 : _a.data;
    if (typeof (responseData === null || responseData === void 0 ? void 0 : responseData.message) === "string" && responseData.message.trim().length > 0) {
        return responseData.message;
    }
    if (typeof (responseData === null || responseData === void 0 ? void 0 : responseData.error) === "string" && responseData.error.trim().length > 0) {
        return responseData.error;
    }
    if ((responseData === null || responseData === void 0 ? void 0 : responseData.errors) && typeof responseData.errors === "object") {
        for (var key in responseData.errors) {
            if (!Object.prototype.hasOwnProperty.call(responseData.errors, key)) {
                continue;
            }
            var firstErrorGroup = responseData.errors[key];
            if (Array.isArray(firstErrorGroup) && typeof firstErrorGroup[0] === "string") {
                return firstErrorGroup[0];
            }
        }
    }
    return fallbackMessage;
};
var shouldContinuePolling = function (status) {
    if (!status) {
        return false;
    }
    return status === "pending";
};
export var CheckoutProvider = function (_a) {
    var children = _a.children;
    var _b = useState(null), selectedTip = _b[0], setSelectedTip = _b[1];
    var _c = useState("none"), paymentType = _c[0], setPaymentType = _c[1];
    var _d = useState(false), smsUpdates = _d[0], setSmsUpdates = _d[1];
    var _e = useState(false), shouldSendSmsAlerts = _e[0], setShouldSendSmsAlerts = _e[1];
    var _f = useState(false), hasMarketingOptIn = _f[0], setHasMarketingOptIn = _f[1];
    var _g = useState(""), smsNumber = _g[0], setSmsNumber = _g[1];
    var _h = useState(false), isCurbsideOrder = _h[0], setIsCurbsideOrder = _h[1];
    var _j = useState(false), orderSubmitted = _j[0], setOrderSubmitted = _j[1];
    var _k = useState(null), submittedOrder = _k[0], setSubmittedOrder = _k[1];
    var _l = useState(null), orderStatus = _l[0], setOrderStatus = _l[1];
    var isSubmittingRef = useRef(false);
    var _m = useAuth(), refreshUserHistory = _m.refreshUserHistory, user = _m.user;
    var persistedMarketingOptIn = user === null || user === void 0 ? void 0 : user.has_marketing_opt_in;
    var hasPersistedMarketingOptIn = persistedMarketingOptIn === true
        || persistedMarketingOptIn === 1
        || (typeof persistedMarketingOptIn === "string" && ["1", "true"].includes(persistedMarketingOptIn.trim().toLowerCase()));
    var isCardPaymentSelected = paymentType === "credit"
        || paymentType === "apple_pay"
        || paymentType === "google_pay"
        || paymentType.startsWith("saved-");
    var verifyDeliveryAddressForCheckout = useCallback(function (serviceType, address) {
        if (!isDeliveryServiceType(serviceType)) {
            return true;
        }
        if (!hasAddressSet(address)) {
            throw new CheckoutValidationError("A delivery address must be selected before checkout.", "DELIVERY_ADDRESS_REQUIRED");
        }
        return true;
    }, []);
    var verifySelectedFutureTime = useCallback(function (datetime, serviceTypeId) { return __awaiter(void 0, void 0, void 0, function () {
        var businessDate, _a, _b, month, _c, day, _d, year, normalizedBusinessDate;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    if (!datetime || serviceTypeId === null) {
                        return [2 /*return*/, false];
                    }
                    businessDate = datetime.split(" ")[0] || "";
                    _a = businessDate.split("/"), _b = _a[0], month = _b === void 0 ? "" : _b, _c = _a[1], day = _c === void 0 ? "" : _c, _d = _a[2], year = _d === void 0 ? "" : _d;
                    if (!month || !day || !year) {
                        return [2 /*return*/, false];
                    }
                    normalizedBusinessDate = "".concat(year, "-").concat(month.padStart(2, "0"), "-").concat(day.padStart(2, "0"));
                    return [4 /*yield*/, client.post("/store/deferred/check", {
                            service_type_id: serviceTypeId,
                            date_to_check: datetime,
                            business_date: normalizedBusinessDate,
                        })];
                case 1:
                    _e.sent();
                    return [2 /*return*/, true];
            }
        });
    }); }, []);
    var applyDiscount = useCallback(function (codeInput) { return __awaiter(void 0, void 0, void 0, function () {
        var normalizedCode, response;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    normalizedCode = Array.isArray(codeInput) ? (_a = codeInput[0]) === null || _a === void 0 ? void 0 : _a.trim() : codeInput.trim();
                    if (!normalizedCode) {
                        return [2 /*return*/, null];
                    }
                    return [4 /*yield*/, client.post("/cart/discounts/add/api", {
                            code: normalizedCode,
                        })];
                case 1:
                    response = _c.sent();
                    return [2 /*return*/, (_b = response.data) !== null && _b !== void 0 ? _b : null];
            }
        });
    }); }, []);
    var clearDiscounts = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, client.get("/cart/discounts/clearAll/api")];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, []);
    var finalizeOrder = useCallback(function (args) { return __awaiter(void 0, void 0, Promise, function () {
        var nextPaymentType, nextServiceType, isDelivery, payload, normalizedSmsNumber, response, order, nextStatus, error_1;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (isSubmittingRef.current) {
                        return [2 /*return*/, {
                                order: null,
                                errorMessage: "Order submission is already in progress.",
                            }];
                    }
                    isSubmittingRef.current = true;
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 4, 5, 6]);
                    nextPaymentType = (_a = args === null || args === void 0 ? void 0 : args.paymentType) !== null && _a !== void 0 ? _a : paymentType;
                    nextServiceType = (_b = args === null || args === void 0 ? void 0 : args.serviceType) !== null && _b !== void 0 ? _b : null;
                    isDelivery = isDeliveryServiceType(nextServiceType);
                    payload = {
                        payment_type: nextPaymentType,
                        sms_updates: smsUpdates,
                        should_send_sms_alerts: shouldSendSmsAlerts,
                        has_marketing_opt_in: hasPersistedMarketingOptIn || hasMarketingOptIn,
                        is_curbside_order: isCurbsideOrder,
                    };
                    if (selectedTip !== null) {
                        payload.tip_amount = selectedTip;
                    }
                    normalizedSmsNumber = normalizeSmsNumber(smsNumber);
                    if (normalizedSmsNumber) {
                        payload.sms_number = normalizedSmsNumber;
                    }
                    if (typeof (args === null || args === void 0 ? void 0 : args.cartId) !== "undefined" && args.cartId !== null) {
                        payload.cart_id = args.cartId;
                    }
                    if (typeof (args === null || args === void 0 ? void 0 : args.userId) !== "undefined" && args.userId !== null) {
                        payload.user_id = args.userId;
                    }
                    if (typeof (args === null || args === void 0 ? void 0 : args.comment) !== "undefined") {
                        payload.comment = args.comment;
                    }
                    if (typeof (args === null || args === void 0 ? void 0 : args.deferDatetime) !== "undefined") {
                        payload.defer_datetime = args.deferDatetime;
                    }
                    if (typeof (args === null || args === void 0 ? void 0 : args.serviceTypeId) !== "undefined" && args.serviceTypeId !== null) {
                        payload.st_id = args.serviceTypeId;
                    }
                    else if (nextServiceType === null || nextServiceType === void 0 ? void 0 : nextServiceType.id) {
                        payload.st_id = nextServiceType.id;
                    }
                    if (isDelivery && typeof (args === null || args === void 0 ? void 0 : args.addressId) !== "undefined" && args.addressId !== null) {
                        payload.address_id = args.addressId;
                    }
                    return [4 /*yield*/, client.post("/cart/finalize/api", payload)];
                case 2:
                    response = _d.sent();
                    order = (_c = response.data) !== null && _c !== void 0 ? _c : null;
                    if (!order) {
                        return [2 /*return*/, {
                                order: null,
                                errorMessage: GENERIC_FINALIZE_ERROR,
                            }];
                    }
                    nextStatus = typeof order.status === "string" ? order.status : null;
                    PersistenceManager.clearUserRewardsInfo();
                    return [4 /*yield*/, refreshUserHistory()];
                case 3:
                    _d.sent();
                    setPaymentType(nextPaymentType);
                    setSubmittedOrder(order);
                    setOrderStatus(nextStatus);
                    setOrderSubmitted(true);
                    return [2 /*return*/, {
                            order: order,
                            errorMessage: null,
                        }];
                case 4:
                    error_1 = _d.sent();
                    return [2 /*return*/, {
                            order: null,
                            errorMessage: extractFriendlyMessage(error_1, GENERIC_FINALIZE_ERROR),
                        }];
                case 5:
                    isSubmittingRef.current = false;
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); }, [hasPersistedMarketingOptIn, hasMarketingOptIn, isCurbsideOrder, paymentType, selectedTip, shouldSendSmsAlerts, refreshUserHistory, smsNumber, smsUpdates]);
    var pollOrderStatus = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, nextOrder, nextStatus;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!orderSubmitted || !(submittedOrder === null || submittedOrder === void 0 ? void 0 : submittedOrder.id)) {
                        return [2 /*return*/, null];
                    }
                    return [4 /*yield*/, client.post("/order/status", {
                            order_id: submittedOrder.id,
                        })];
                case 1:
                    response = _c.sent();
                    nextOrder = (_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.order) !== null && _b !== void 0 ? _b : null;
                    if (!nextOrder) {
                        return [2 /*return*/, null];
                    }
                    nextStatus = typeof nextOrder.status === "string" ? nextOrder.status : null;
                    setSubmittedOrder(nextOrder);
                    setOrderStatus(nextStatus);
                    if (nextStatus === "POS_Complete") {
                        setOrderSubmitted(false);
                    }
                    return [2 /*return*/, nextOrder];
            }
        });
    }); }, [orderSubmitted, submittedOrder]);
    useEffect(function () {
        if (!orderSubmitted || !shouldContinuePolling(orderStatus)) {
            return;
        }
        var interval = window.setInterval(function () {
            pollOrderStatus().catch(function () {
                // polling failures should not break checkout state
            });
        }, 15000);
        return function () {
            window.clearInterval(interval);
        };
    }, [orderSubmitted, orderStatus, pollOrderStatus]);
    var value = useMemo(function () { return ({
        selectedTip: selectedTip,
        paymentType: paymentType,
        isCardPaymentSelected: isCardPaymentSelected,
        smsUpdates: smsUpdates,
        shouldSendSmsAlerts: shouldSendSmsAlerts,
        hasMarketingOptIn: hasMarketingOptIn,
        smsNumber: smsNumber,
        isCurbsideOrder: isCurbsideOrder,
        orderSubmitted: orderSubmitted,
        orderStatus: orderStatus,
        submittedOrder: submittedOrder,
        setSelectedTip: setSelectedTip,
        setPaymentType: setPaymentType,
        setSmsUpdates: setSmsUpdates,
        setShouldSendSmsAlerts: setShouldSendSmsAlerts,
        setHasMarketingOptIn: setHasMarketingOptIn,
        setSmsNumber: setSmsNumber,
        setIsCurbsideOrder: setIsCurbsideOrder,
        verifyDeliveryAddressForCheckout: verifyDeliveryAddressForCheckout,
        verifySelectedFutureTime: verifySelectedFutureTime,
        applyDiscount: applyDiscount,
        clearDiscounts: clearDiscounts,
        finalizeOrder: finalizeOrder,
        pollOrderStatus: pollOrderStatus,
    }); }, [
        selectedTip,
        paymentType,
        isCardPaymentSelected,
        smsUpdates,
        shouldSendSmsAlerts,
        hasMarketingOptIn,
        smsNumber,
        isCurbsideOrder,
        orderSubmitted,
        orderStatus,
        submittedOrder,
        verifyDeliveryAddressForCheckout,
        verifySelectedFutureTime,
        applyDiscount,
        clearDiscounts,
        finalizeOrder,
        pollOrderStatus,
        setShouldSendSmsAlerts,
        setHasMarketingOptIn,
        setSmsNumber,
    ]);
    return (React.createElement(CheckoutContext.Provider, { value: value }, children));
};
export var useCheckout = function () {
    var context = useContext(CheckoutContext);
    if (!context) {
        throw new Error("useCheckout must be used within a CheckoutProvider");
    }
    return context;
};
